module.exports = __webpack_public_path__ + "img/1.1ccbf9c1.png";